import { Filter } from '../types';
import { createContext } from 'react';

const FilterContext = createContext<Filter | undefined>(undefined);

export default FilterContext;
